module.exports = __webpack_public_path__ + "static/media/sample6.31baa910.jpg";